import React from 'react';
import Accordion from '@mui/material/Accordion';
import Typography from '@mui/material/Typography';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import {
  AccordionSummary,
  AccordionDetails,
  useStyles,
} from 'styles/pages/product-detail/accordion';
import { Description as StyledDescription } from 'styles/pages/product-detail/description';

const Description = ({ data }) => {
  const classes = useStyles();

  return (
    <Accordion className={classes.accordion} defaultExpanded>
      <AccordionSummary expandIcon={<ExpandMoreIcon />}>
        <Typography className={classes.heading}>Description</Typography>
      </AccordionSummary>
      <AccordionDetails>
        <StyledDescription
          dangerouslySetInnerHTML={{ __html: data?.Product?.Description }}
        />
      </AccordionDetails>
    </Accordion>
  );
};

export default Description;
